import React from "react";

export default function GetInvolved() {
  return <div>GetInvolved</div>;
}
